import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pas4',
  templateUrl: './pas4.component.html',
  styleUrls: ['./pas4.component.scss']
})
export class Pas4Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
